/* eslint-disable */

import { HOST } from "./model/classmates/constant";

export default {
  // getClassroomMock: {
  //   method: "get",
  //   restful: true,
  //   path: "p/{cpid}/lesson/classroom/{id}"
  // },
  // getBigroomMock: {
  //   restful: true,
  //   path: "p/{cpid}/study/classroom/{id}"
  // },
  // getResourceMock: {
  //   method: "get",
  //   restful: true,
  //   path: "p/{cpid}/resource/{id}"
  // },
  // getBigClassroomRecord: {
  //   restful: true,
  //   path: 'p/{cpid}/study/classroom/{id}/record'
  // },
  //
  //
  // getClassroomRecord: {
  //   restful: true,
  //   path: "p/{cpid}/lesson/classroom/{id}/record"
  // },
  // getClassroomCollectList: {
  //   restful: true,
  //   path: "p/{cpid}/study/classroom/{id}/collection"
  // },
  // postClassroom: {
  //   method: "post",
  //   restful: true,
  //   path: "p/{cpid}/lesson/classroom/{id}/record"
  // },
  // postBigClassRoom: {
  //   method: "post",
  //   restful: true,
  //   path: "p/{cpid}/study/classroom/{id}/record"
  // },

  // postCollect: {
  //   method: "post",
  //   restful: true,
  //   path: "p/{cpid}/resource/{resource_id}/collection"
  //
  // },
  //
  // deleteCollect: {
  //   method: "delete",
  //   restful: true,
  //   path: "p/{cpid}/resource/{resource_id}/collection"
  // },
  // getNoteShare: {
  //   path: "p/{cpid}/resource/{resource_id}/share",
  //   restful: true
  // },
  // postFeedBackText: {
  //   method: "post",
  //   path: "feedback/resource",
  //   restful: true
  // },
  // getSignInfo: {
  //   path: "p/{pid}/study/classroom/{id}/punchin",
  //   restful: true
  // },
  // postSignInfo: {
  //   path: "p/{pid}/study/classroom/{id}/punchin",
  //   method: "post",
  //   restful: true
  // },
  // getSignShare: {
  //   path: "classroom/punchin"
  // },
  // postAdInfo: {
  //   path: "p/{pid}/register/get",
  //   method: "post",
  //   restful: true
  // },

  //小课同学
  // getUserInfo: {
  //   path: "/panda/chat/users",
  //   host: HOST
  // },
  // getEmoj: {
  //   path: "/panda/chat/mojis",
  //   host: HOST
  // },
  //清除记录重新开始课堂
  // postRestudy: {
  //   path: 'p/{plan_id}/study/classroom/{id}/record/relearn',
  //   method: "post",
  //   restful: true
  //
  // },
  // postPuzzle: {
  //   path: 'p/{plan_id}/resource/{resource_id}/hesitation',
  //   method: "post",
  //   restful: true
  //
  // },

  //请求课程表
  // getOutlines: {
  //   url:  'https://prod.pandateacher.com/panda-school/api-enrollment/study/plan/{plan_id}/outlines',
  //   restful: true
  // },
  getClassLists: {
    path: "/interact/{classroom_id}",
    restful: true
  },
  getResource: {
    path: "/interact/resource/{resource_id}",
    restful: true
  },
  postClassroomRecord: {
    method: "post",
    restful: true,
    path: "/interact/{classroom_id}/record"
  },
  getClassroomRecord: {
    restful: true,
    path: "/interact/{classroom_id}/record"
  },
  getRegistrationEntrance: {
    restful: true,
    path: "/interact/{classroom_id}/introduction",
    method: "get"
  },
  getShareStatus: {
    restful: true,
    path: "/interact/{classroom_id}/learning-share/records",
    method: "get"
  }
};



// WEBPACK FOOTER //
// ./src/modules/min-lesson/apis.js